export default __webpack_public_path__ + "static/media/Paid_Yellow_Sticker.5fe300cd.png";